/**
 * @generated SignedSource<<3fa309a9359260a30502f009521ccaed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SeoableType = "COUNTRY" | "PACKAGE" | "PAGE" | "WHAT_TO_SEE";
export type SeoTabCheckSlugQuery$variables = {
  exclude?: ReadonlyArray<string> | null;
  slug: string;
  type: SeoableType;
};
export type SeoTabCheckSlugQuery$data = {
  readonly slugExists: {
    readonly seoable: {
      readonly id: string;
    };
  } | null;
};
export type SeoTabCheckSlugQuery = {
  response: SeoTabCheckSlugQuery$data;
  variables: SeoTabCheckSlugQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "exclude"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v3 = [
  {
    "kind": "Variable",
    "name": "exclude",
    "variableName": "exclude"
  },
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  },
  {
    "kind": "Variable",
    "name": "type",
    "variableName": "type"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SeoTabCheckSlugQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Seo",
        "kind": "LinkedField",
        "name": "slugExists",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "seoable",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SeoTabCheckSlugQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Seo",
        "kind": "LinkedField",
        "name": "slugExists",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "seoable",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ff19ed96975c96ba0151576f97b82d37",
    "id": null,
    "metadata": {},
    "name": "SeoTabCheckSlugQuery",
    "operationKind": "query",
    "text": "query SeoTabCheckSlugQuery(\n  $slug: String!\n  $type: SeoableType!\n  $exclude: [ID!]\n) {\n  slugExists(slug: $slug, type: $type, exclude: $exclude) {\n    seoable {\n      __typename\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8ce1826008b2e630cb22030eb55c4b01";

export default node;
